import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const GroupIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "GroupGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M9.70474 6.34419C8.50689 6.34419 7.53265 5.36995 7.53265 4.17209C7.53265 2.97424 8.50689 2 9.70474 2C10.9026 2 11.8768 2.97424 11.8768 4.17209C11.8768 5.36995 10.9026 6.34419 9.70474 6.34419ZM9.70474 3.00872C9.06346 3.00872 8.54137 3.53081 8.54137 4.17209C8.54137 4.81338 9.06346 5.33547 9.70474 5.33547C10.346 5.33547 10.8681 4.81338 10.8681 4.17209C10.8681 3.53081 10.346 3.00872 9.70474 3.00872Z"
        fill="#696969"
      />
      <path
        d="M10.7548 22C10.3505 22 9.98156 21.8444 9.70474 21.5912C9.42794 21.8444 9.05902 22 8.65465 22C7.79763 22 7.10019 21.3026 7.10019 20.4455V15.2581C6.93026 15.3222 6.74655 15.3566 6.55446 15.3566C5.69744 15.3566 5 14.6592 5 13.8022V9.5437C5 8.30841 6.00527 7.30364 7.24056 7.30364H12.1689C13.4042 7.30364 14.4094 8.30841 14.4094 9.5437V13.8022C14.4094 14.6592 13.712 15.3566 12.855 15.3566C12.6629 15.3566 12.4792 15.3222 12.3093 15.2581V20.4455C12.3093 21.3026 11.6119 22 10.7548 22ZM9.70474 19.9412C9.98352 19.9412 10.2091 20.1668 10.2091 20.4455C10.2091 20.746 10.4539 20.9913 10.7548 20.9913C11.0558 20.9913 11.3006 20.746 11.3006 20.4455V13.8022C11.3006 13.5234 11.5262 13.2978 11.8049 13.2978C12.0837 13.2978 12.3093 13.5234 12.3093 13.8022C12.3093 14.1026 12.5541 14.3479 12.855 14.3479C13.156 14.3479 13.4008 14.1026 13.4008 13.8022V9.5437C13.4008 8.86498 12.8481 8.31236 12.1689 8.31236H7.2406C6.56139 8.31236 6.00876 8.86498 6.00876 9.5437V13.8022C6.00876 14.1026 6.25355 14.3479 6.5545 14.3479C6.85544 14.3479 7.10023 14.1026 7.10023 13.8022C7.10023 13.5234 7.32581 13.2978 7.60459 13.2978C7.88337 13.2978 8.10895 13.5234 8.10895 13.8022V20.4455C8.10895 20.746 8.35375 20.9913 8.65469 20.9913C8.95563 20.9913 9.20042 20.746 9.20042 20.4455C9.20042 20.1668 9.42596 19.9412 9.70474 19.9412Z"
        fill="#696969"
      />
      <path
        d="M9.70474 20.9499C9.42596 20.9499 9.20042 20.7243 9.20042 20.4455L9.20038 13.9086C9.20038 13.6298 9.42596 13.4042 9.70474 13.4042C9.98352 13.4042 10.2091 13.6298 10.2091 13.9086V20.4455C10.2091 20.7243 9.98352 20.9499 9.70474 20.9499Z"
        fill="#696969"
      />
      <path
        d="M11.8049 14.3066C11.5261 14.3066 11.3006 14.081 11.3006 13.8022L11.3006 10.6332C11.3006 10.3544 11.5261 10.1288 11.8049 10.1288C12.0837 10.1288 12.3093 10.3544 12.3093 10.6332L12.3093 13.8022C12.3093 14.081 12.0837 14.3066 11.8049 14.3066Z"
        fill="#696969"
      />
      <path
        d="M7.58929 14.3066C7.31051 14.3066 7.08493 14.081 7.08493 13.8022V10.6332C7.08493 10.3544 7.31051 10.1288 7.58929 10.1288C7.86807 10.1288 8.09365 10.3544 8.09365 10.6332V13.8022C8.09365 14.081 7.86807 14.3066 7.58929 14.3066Z"
        fill="#696969"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.3452 6.69256C14.3267 6.69256 13.4984 5.86445 13.4984 4.84628C13.4984 3.8281 14.3267 3 15.3452 3C16.3636 3 17.1919 3.8281 17.1919 4.84628C17.1919 5.86445 16.3636 6.69256 15.3452 6.69256ZM15.3452 3.85741C14.7999 3.85741 14.3561 4.30119 14.3561 4.84628C14.3561 5.39137 14.7999 5.83515 15.3452 5.83515C15.8904 5.83515 16.3343 5.39137 16.3343 4.84628C16.3343 4.30119 15.8904 3.85741 15.3452 3.85741ZM16.238 20C15.8942 20 15.5805 19.8677 15.3452 19.6525C15.1098 19.8677 14.7962 20 14.4524 20C13.7237 20 13.1308 19.4072 13.1308 18.6787V15.3322C13.4661 15.2719 13.7644 15.1037 13.9884 14.8649V18.6787C13.9884 18.9341 14.1965 19.1426 14.4524 19.1426C14.7083 19.1426 14.9164 18.9341 14.9164 18.6787L14.9164 13.1223C14.9164 12.8853 15.1082 12.6936 15.3452 12.6936C15.5822 12.6936 15.774 12.8853 15.774 13.1223V18.6787C15.774 18.9341 15.9821 19.1426 16.238 19.1426C16.4938 19.1426 16.702 18.9341 16.702 18.6787V13.0319L16.702 10.3382C16.702 10.1013 16.8937 9.90952 17.1308 9.90952C17.3678 9.90952 17.5596 10.1013 17.5596 10.3382L17.5596 13.0319C17.5596 13.2872 17.7677 13.4957 18.0236 13.4957C18.2794 13.4957 18.4876 13.2872 18.4876 13.0319V9.41215C18.4876 8.83524 18.0177 8.3655 17.4403 8.3655H14.0738C13.8444 7.99618 13.5106 7.69814 13.114 7.5129C13.159 7.50971 13.2043 7.50809 13.2501 7.50809H17.4402C18.4905 7.50809 19.3452 8.36215 19.3452 9.41215V13.0319C19.3452 13.7603 18.7522 14.3531 18.0235 14.3531C17.8602 14.3531 17.704 14.3238 17.5596 14.2694V18.6787C17.5596 19.4072 16.9666 20 16.238 20Z"
        fill="#696969"
      />
    </svg>
  );
};

export default GroupIcon;
